import { Divider } from "@mui/material";
import { useAllowCorporateDashboard } from "hooks/useAllowCorporateDashboard";
import DowntimeDashboardLink from "./components/DowntimeDashboardLink.view";
import LocationsMenu from "./components/LocationsMenu.view";

// Aspen-Birch rebrand: these items render in the top-bar "Locations" dropdown.
// Settings + Help moved to the user menu, and the API Key Management link
// (added on dev as a drawer item) now lives in the user menu as well — so only
// the dashboard link and the locations tree (mills, plus Division > Region
// groups) remain here.
const DowntimeAppDrawerItems = () => {
    const { isAllowedToUseCorporateDashboard } = useAllowCorporateDashboard();
    return (
        <>
            {isAllowedToUseCorporateDashboard && (
                <>
                    <DowntimeDashboardLink />
                    <Divider sx={{ my: 0.5 }} />
                </>
            )}
            <LocationsMenu hideRoot />
        </>
    );
};

export default DowntimeAppDrawerItems;
